import { call, put, takeLatest } from "redux-saga/effects";
import { onGetClientMaster, onGetClientMasterError, onGetClientMasterSuccess } from "../Store/Slices/clientMasterSlice";
import { callClientMasterGetApi } from "../Context/clientMasterApi";
import { rewardWidgetConfigDataGetApi } from "../Context/rewardWidgetDataApi";
import { onGetClientConfigData, onGetClientConfigDataError, onGetClientConfigDataSuccess } from "../Store/Slices/clientConfigDataSlice";
function* GetClientMaster({ payload }) {
  try {
    const getClientMasterResponse = yield call(callClientMasterGetApi, payload);
    if (getClientMasterResponse.httpStatusCode === "200") {
      yield put(
        onGetClientMasterSuccess({
          data: getClientMasterResponse.response,
          message: getClientMasterResponse.errorMessage,
          status_code: getClientMasterResponse.httpStatusCode
        })
      );
    } else {
      yield put(
        onGetClientMasterError({
          data: getClientMasterResponse.response,
          message: getClientMasterResponse.response.message,
          status_code: getClientMasterResponse.httpStatusCode
        })
      );
    }
  } catch (error) {
    const message = error.response.data.errorMessage || "Something went wrong";
    yield put(onGetClientMasterError({ data: [], message, status_code: 400 }));
  }
}

function* GetClientConfigData({ payload }) {
  try {
    const getClientConfigDataResponse = yield call(rewardWidgetConfigDataGetApi, payload);
    if (getClientConfigDataResponse.httpStatusCode === "200") {
      yield put(
        onGetClientConfigDataSuccess({
          data: getClientConfigDataResponse.response,
          message: getClientConfigDataResponse.errorMessage,
          status_code: getClientConfigDataResponse.httpStatusCode
        })
      );
    } else {
      yield put(
        onGetClientConfigDataError({
          data: getClientConfigDataResponse.response,
          message: getClientConfigDataResponse.response.message,
          status_code: getClientConfigDataResponse.httpStatusCode
        })
      );
    }
  } catch (error) {
    const message = error.response.data.errorMessage || "Something went wrong";
    yield put(onGetClientConfigDataError({ data: [], message, status_code: 400 }));
  }
}
export default function* clientMasterSaga() {
  yield takeLatest(onGetClientMaster.type, GetClientMaster);
  yield takeLatest(onGetClientConfigData.type, GetClientConfigData);
}
